import { RestClient } from "./restClient";

export class BaseMapsService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}
	getAllBaseMaps(callback) {
		const url = "/ecosystem/api/mapStyles";
		this._restClient.exec_get(url, callback);
	}
}
